var map = {
	"./andere.png": "bae9",
	"./arrow.jpg": "e35b",
	"./browser.png": "43f2",
	"./ch.png": "cb12",
	"./checkmark.png": "d7dd",
	"./classroom.svg": "a89c",
	"./classroom_default.png": "bbef",
	"./classroom_digital.png": "5b45",
	"./cloud.png": "0e0a",
	"./cloud_full.png": "aa23",
	"./de.png": "ce65",
	"./draw.png": "9851",
	"./dsgvo.png": "e9d8",
	"./inpirationen.png": "a3a4",
	"./instruction1.jpg": "a91b",
	"./instruction2.jpg": "dc44",
	"./instruction3.jpg": "ddb3",
	"./instruction4.jpg": "9ecf",
	"./instruction5.jpg": "15b0",
	"./it-verantwortlicher.png": "d11a",
	"./kommission.png": "04af",
	"./laptop.png": "d897",
	"./lehrer.png": "8591",
	"./logo.png": "cf05",
	"./man.png": "d378",
	"./palette.png": "176d",
	"./prozessorientiertes-denken.png": "4f69",
	"./rocket.png": "3e0f",
	"./secure.png": "6822",
	"./summary.png": "1602",
	"./tafel.png": "fc26",
	"./user.png": "c121"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";